import type { Maybe } from '@web-platform/shared-universal-types-utils/src/utils';

export const GRPC_STATUS_CODES = {
  CANCELLED: 'CANCELLED',
  UNKNOWN: 'UNKNOWN',
  INVALID_ARGUMENT: 'INVALID_ARGUMENT',
  DEADLINE_EXCEEDED: 'DEADLINE_EXCEEDED',
  NOT_FOUND: 'NOT_FOUND',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  RESOURCE_EXHAUSTED: 'RESOURCE_EXHAUSTED',
  FAILED_PRECONDITION: 'FAILED_PRECONDITION',
  ABORTED: 'ABORTED',
  OUT_OF_RANGE: 'OUT_OF_RANGE',
  UNIMPLEMENTED: 'UNIMPLEMENTED',
  INTERNAL: 'INTERNAL',
  UNAVAILABLE: 'UNAVAILABLE',
  DATA_LOSS: 'DATA_LOSS',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
} as const;

export const grpcErrorStatusCodes = {
  1: GRPC_STATUS_CODES.CANCELLED,
  2: GRPC_STATUS_CODES.UNKNOWN,
  3: GRPC_STATUS_CODES.INVALID_ARGUMENT,
  4: GRPC_STATUS_CODES.DEADLINE_EXCEEDED,
  5: GRPC_STATUS_CODES.NOT_FOUND,
  6: GRPC_STATUS_CODES.ALREADY_EXISTS,
  7: GRPC_STATUS_CODES.PERMISSION_DENIED,
  8: GRPC_STATUS_CODES.RESOURCE_EXHAUSTED,
  9: GRPC_STATUS_CODES.FAILED_PRECONDITION,
  10: GRPC_STATUS_CODES.ABORTED,
  11: GRPC_STATUS_CODES.OUT_OF_RANGE,
  12: GRPC_STATUS_CODES.UNIMPLEMENTED,
  13: GRPC_STATUS_CODES.INTERNAL,
  14: GRPC_STATUS_CODES.UNAVAILABLE,
  15: GRPC_STATUS_CODES.DATA_LOSS,
  16: GRPC_STATUS_CODES.UNAUTHENTICATED,
} as const;

const grpcToHttpMapping = {
  [GRPC_STATUS_CODES.CANCELLED]: 499, // 499 Client Closed Request
  [GRPC_STATUS_CODES.UNKNOWN]: 500, // 500 Internal Server Error
  [GRPC_STATUS_CODES.INVALID_ARGUMENT]: 400, // 400 Bad Request
  [GRPC_STATUS_CODES.DEADLINE_EXCEEDED]: 504, // 504 Gateway Timeout
  [GRPC_STATUS_CODES.NOT_FOUND]: 404, // 404 Not Found
  [GRPC_STATUS_CODES.ALREADY_EXISTS]: 409, // 409 Conflict
  [GRPC_STATUS_CODES.PERMISSION_DENIED]: 403, // 403 Forbidden
  [GRPC_STATUS_CODES.RESOURCE_EXHAUSTED]: 429, // 429 Too Many Requests
  [GRPC_STATUS_CODES.FAILED_PRECONDITION]: 412, // 412 Precondition Failed
  [GRPC_STATUS_CODES.ABORTED]: 409, // 409 Conflict
  [GRPC_STATUS_CODES.OUT_OF_RANGE]: 400, // 400 Bad Request
  [GRPC_STATUS_CODES.UNIMPLEMENTED]: 501, // 501 Not Implemented
  [GRPC_STATUS_CODES.INTERNAL]: 500, // 500 Internal Server Error
  [GRPC_STATUS_CODES.UNAVAILABLE]: 503, // 503 Service Unavailable
  [GRPC_STATUS_CODES.DATA_LOSS]: 500, // 500 Internal Server Error
  [GRPC_STATUS_CODES.UNAUTHENTICATED]: 401, // 401 Unauthorized
} as const;

const isSupportedGrpcErrorCode = (
  errorCode: Maybe<number>,
): errorCode is keyof typeof grpcErrorStatusCodes =>
  !!(errorCode && errorCode in grpcErrorStatusCodes);

export const mapGrpcToHttpStatusCode = (grpcNumericalCode: Maybe<number>) => {
  if (isSupportedGrpcErrorCode(grpcNumericalCode)) {
    const grpcStatusCode = grpcErrorStatusCodes[grpcNumericalCode];
    return grpcToHttpMapping[grpcStatusCode];
  }

  return undefined;
};
